import { render, staticRenderFns } from "./ReduceDebt.vue?vue&type=template&id=09a2080b&scoped=true&"
import script from "./ReduceDebt.vue?vue&type=script&lang=js&"
export * from "./ReduceDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2080b",
  null
  
)

export default component.exports